import AppError from './classes/AppError';

/**
 * Settings for this app.
 */
export interface ISettingsType {
  postWrapper: string;
  postsWrapper: string;
  paginationWrapper: string;
  nextPageSelector: string;
  loaderType: 'loadMore' | 'infinite';
  loadMoreMarkup: string;
  infiniteMarkup: string;
  infiniteScrollLoadThreshold: number;
}

function isValid(o: ISettingsType): o is ISettingsType {
  return (
    typeof o.postWrapper === 'string' &&
    typeof o.postsWrapper === 'string' &&
    typeof o.paginationWrapper === 'string' &&
    typeof o.nextPageSelector === 'string' &&
    typeof o.loaderType === 'string' &&
    (o.loaderType === 'loadMore' || o.loaderType === 'infinite') &&
    typeof o.loadMoreMarkup === 'string' &&
    typeof o.infiniteMarkup === 'string' &&
    typeof o.infiniteScrollLoadThreshold === 'number'
  );
}

function condition(o: any): ISettingsType {
  o.infiniteScrollLoadThreshold = o.infiniteScrollLoadThreshold
    ? parseInt(o.infiniteScrollLoadThreshold, 10)
    : null;
  return o;
}

export default class Settings {
  private settings: ISettingsType;
  constructor(inputSettings: ISettingsType) {
    this.settings = condition(inputSettings);
    if (!isValid(this.settings)) {
      throw new AppError('Invalid settings input');
    }
  }

  public getSettings(): ISettingsType {
    return this.settings;
  }
}
